<template>
  <aside id="menu">
    <div id="navigation">
      <div>

        <div class="profile-picture">
          <router-link :to="{name: 'Profile'}">
            <img alt="logo" class="img-circle" :src="$apiUrl + '/uploads/user/' + imgProfile" style="height: 100px;width: 100px">
          </router-link>

        </div>
        <div class="text-color text-center">
          <div class="font-extra-bold font-uppercase" style="margin-top: 5px">Not Connected</div>
        </div>
      </div>

      <ul class="nav" id="side-menu">
        <li>
          <a :href="aboutUsUrl"><i class="fa fa-info-circle"></i> About ideXlab</a>
        </li>
        <li>
          <a :href="publicQuestionUrl" id="navigation-publicQuestion" target="_blank"><i class="fa fa-trophy"></i> Public Questions</a>
        </li>
        <li>
          <router-link :to="{name: 'LoginExpert'}"><i class="fas fa-sign-in-alt"></i> Login </router-link>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'NavigationDeco',
  data () {
    return {
      imgProfile: 'avatar.png',
      firstName: null,
      lastName: null,
      hasReceiveQuestion: false,
      publicQuestionUrl: process.env.WEBSITE_URL + '/public-questions',
      aboutUsUrl: process.env.WEBSITE_URL + '/about-us/'
    }
  },
  mounted () {
    $('#side-menu').metisMenu()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/NavigationDeco.vue